const Heading = (prop) => {
	return (
		<>
		<div className="content w3-content">
			<header className="w3-container w3-content" style={{padding: "32px 0"}} id="home">        
				<div>
				  	<h1 className="zblogtitle strong"><b>Blog</b></h1>
				  	<p className="zblogexcerpt">Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia,</p>
				</div>
			</header>
		</div>
		</>
	)
}
export default Heading